/* zf-product-card: quick add for single-variant products ([data-zf-quick-add="variantId"]). */
(function () {
  if (window.zfQuickAddBound) return;
  window.zfQuickAddBound = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zf-quick-add]');
    if (!btn || btn.disabled || typeof window.zfAddToCart !== 'function') return;
    e.preventDefault();
    const err = btn.parentElement.querySelector('.zf-card-product__error, [data-zf-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.setAttribute('aria-busy', 'true');
    try {
      await window.zfAddToCart([{ id: Number(btn.dataset.zfQuickAdd), quantity: 1 }], btn);
    } catch (error) {
      if (err) { err.textContent = error.message; err.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
})();
